export function formatBudget(budget: any) {
    if (!budget) return "TBD";
    let value = typeof budget === "number" ? budget : null;

    if (value === null) {
        // Remove non-numeric characters except dot and comma
        let numericString = budget.replace(/[^0-9.,]/g, '');
        // Remove commas for parsing
        numericString = numericString.replace(/,/g, '');
        // Convert to number
        value = parseFloat(numericString);
    }
    // Check if value is 0, NaN, or falsy
    if (!value) return "TBD";

    return budget;
}


export const sanitizePercent = (v: string) => {
    v = v.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");

    if (v === ".") return "0.";

    const [i, d = ""] = v.split(".");
    const decimals = d.slice(0, 2);

    let value = decimals ? `${i}.${decimals}` : i;

    // allow typing trailing dot (12. , 0.)
    if (v.endsWith(".")) return value + ".";

    const n = Number(value);

    if (isNaN(n)) return "";

    return n > 100 ? "100" : value;
};

export const perfectNumber = (v: number) => Number(v.toFixed(2));